import React, { useState, useMemo } from 'react';

import FieldSelector from '../farm/field/selector.js';
import DatePicker from "react-datepicker";
import InputWrapper from '../forms/InputWrapper.js';
import WeightInput from '../forms/ManagedWeightInput.js';

import { callback } from '../../helpers.js';


export default (props) => {

	const onChange = (e) => {
		if (!e.hasOwnProperty('target'))
			e = {'target': {'name': 'field', 'value': e}}
		console.log(e);
		callback(props.onChange, [e]);
	}
	
	console.log("ROW", props);
	return <div className="harvest-row">
		<InputWrapper label="Field: "  info="A field harvested.">
			<FieldSelector field={props.field} from={props.date} until={props.date} onChange={onChange} />
		</InputWrapper>
		<InputWrapper label="Weight: "  info="The amount harvested from this field.">
			<WeightInput baseUnits="kg" name="weight" value={props.weight} onChange={onChange} />
		</InputWrapper>
	</div>
}